import React, { useContext, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import {RegistryContext} from "../../../../contexts/RegistryContext";
import PartiesSearchInput from "../../../parties/searchInput";

const CustomerOrSupplier = ({formByReason, newDetail, setModifiedDetail}) => {

  const registryStore = useContext(RegistryContext);
  const [selectedContact, setSelectedContact] = useState({
    id: null,
    name: null,
    vatNumber: null,
    taxId: null
  });

  useEffect(() => {          
    setSelectedContact({
      id: null,
      name: formByReason?.customerOrSupplier?.source==="supplier" ? newDetail?.supplierName : newDetail?.customerName,
      vatNumber: formByReason?.customerOrSupplier?.source==="supplier" ? newDetail?.supplierVATNumber : newDetail?.customerVATNumber,
      taxId: formByReason?.customerOrSupplier?.source==="supplier" ? newDetail?.supplierTaxId : newDetail?.customerTaxId 
    });
  }, [newDetail?.customerName, newDetail?.customerTaxId, newDetail?.customerVATNumber,
    newDetail?.supplierName, newDetail?.supplierVATNumber, newDetail?.supplierTaxId]);
    
  return formByReason && (
    <div style={{width: "250px", display: "flex", flexDirection: "column", gap: 16}}>      
      <div className="pre-cog-detail-header-company-details" style={{gap: 4, paddingLeft: "48px"}}>
        <div data-testid="customerOrSupplier">
          <FormattedMessage id={formByReason?.customerOrSupplier?.label}/> 
          {newDetail?.source !== "B2B" ? 
            (formByReason?.customerOrSupplier?.required && "*") : 
            <b> {selectedContact.name || selectedContact.vatNumber || selectedContact.taxId}</b> 
          }
        </div>
        { 
          newDetail?.source !== "B2B" &&                    
            <PartiesSearchInput
              registryStore={registryStore}        
              disabled={false}
              data-testid="partiesSearchInput"
              getPopupContainer={trigger => trigger.parentNode}
              selected={selectedContact
                ? {
                  id: selectedContact.id,
                  description: selectedContact.name
                }
                : null}
              width={"fit-content"}
              source={formByReason?.customerOrSupplier?.source}
              customStyles={{background: "#fafbfd", height: 40, width: "100%"}}
              onSelect={party => {
                if (!party.description) return;
                setSelectedContact({
                  id: party._meta?.id,
                  name: party.description,
                  vatNumber: party.identifiers?.[1]?.value,
                  taxId: party.identifiers?.[0]?.value
                });
                
                const objToSave = formByReason?.customerOrSupplier?.source === "client" ?
                  {
                    customerName: party.description,
                    customerTaxId: party.identifiers?.[1]?.value || party.identifiers?.[0]?.value,
                    customerVATNumber: party.identifiers?.[0]?.value
                  } :
                  {
                    supplierName: party.description,
                    supplierTaxId: party.identifiers?.[1]?.value || party.identifiers?.[0]?.value,
                    supplierVATNumber: party.identifiers?.[0]?.value
                  };

                setModifiedDetail(objToSave);
              }}
              onClear={() => {
                setSelectedContact({
                  id: null,
                  name: null,
                  vatNumber: null,
                  taxId: null
                });
              }}
              value={selectedContact?.name}
              placeholder="Ricerca per ragione sociale o p.iva"
            />    
        }  
      </div>
      <div className="pre-cog-detail-header-company-details">
        <div style={{paddingLeft: "48px"}}>
          <div data-testid="vatNumber" style={{ marginRight: 10 }}>
            {<FormattedMessage id="preCog.header.vat" />}
            {selectedContact.vatNumber && <b>{selectedContact.vatNumber}</b>}
          </div>
          
        </div>
        <div style={{paddingLeft: "48px"}}>
          <div data-testid="taxIdOrCF" style={{ marginRight: 10 }}>
              C.F.
            {selectedContact.taxId &&
              <b> {selectedContact.taxId}</b>}
          </div>
        </div>
      </div>
      { newDetail?.doc?.sdiCode && newDetail?.source === "B2B" &&
        <div className="pre-cog-detail-header-company-sdi">
          <span style={{paddingLeft: "32px"}}>
            <FormattedMessage id="preCog.header.sdiId" />
            <b>{` ${newDetail?.doc?.sdiCode}`}</b>
          </span>
        </div>
      }
    </div>
  );
};

export default CustomerOrSupplier;